import React, { useState } from "react";
import "./ContactUs.css";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { TextField, Button, Grid, Typography, Box } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import Footer from "../Footer/Footer";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
    alert("Form submitted successfully!");
  };

  return (
    <div className="contact-us-container">
      <div className="contact-details">
        <div className="contact-block">
          <FaMapMarkerAlt className="icon" />
          <h3 className="contact-header">Our Address</h3>
          <p className="contact-para">Sagar, Karnataka, India</p>
        </div>
        <div className="contact-block">
          <FaPhoneAlt className="icon" />
          <h3 className="contact-header">Our Phone</h3>
          <a
            href="https://wa.me/917019444941"
            className="contact-para"
            target="_blank"
            rel="noopener noreferrer"
          >
            +91 9591558610
          </a>
          <br />
          <a
            href="https://wa.me/917019444941"
            className="contact-para"
            target="_blank"
            rel="noopener noreferrer"
          >
            +91 7019444941
          </a>
        </div>
        <div className="contact-block">
          <FaEnvelope className="icon" />
          <h3 className="contact-header">Our Email</h3>
          <a
            href="mailto:Keerthisagaramachi@gmail.com"
            className="contact-para"
          >
            Keerthisagaramachi@gmail.com
          </a>
        </div>
      </div>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          maxWidth: 600,
          margin: "auto",
          marginTop: 4,
          padding: 4,
          boxShadow: 3,
          borderRadius: 2,
          backgroundColor: "#fff",
        }}
      >
        <Typography
          variant="h6"
          gutterBottom
          align="center"
          sx={{ color: "grey.600" }}
        >
          Fill out this form, we will be in touch soon!
        </Typography>

        <Typography variant="h4" gutterBottom align="center">
          How can we help you?
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              variant="outlined"
              type="email"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              variant="outlined"
              type="tel"
              inputProps={{
                maxLength: 10,
                pattern: "[0-9]{10}",
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Subject"
              name="subject"
              required
              value={formData.subject}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Message"
              name="message"
              required
              value={formData.message}
              onChange={handleChange}
              multiline
              rows={4}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              endIcon={<SendIcon />}
              type="submit"
              variant="contained"
              width="100px"
              sx={{
                backgroundColor: "#f9d342",
                color: "black",
                padding: "10px 20px",
                "&:hover": {
                  backgroundColor: "#f9d342",
                },
              }}
              onClick={() => {
                const { name, email, phone, subject, message } = formData;
                const formattedMessage = `*Contact Form Submission*\n\n*Name:* ${name}\n*Email:* ${email}\n*Phone:* ${phone}\n*Subject:* ${subject}\n*Message:* ${message}`;
                const encodedMessage = encodeURIComponent(formattedMessage);
                const whatsappUrl = `https://wa.me/917019444941?text=${encodedMessage}`;
                window.open(whatsappUrl, "_blank");
              }}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </div>
  );
};

export default ContactUs;
